<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
          <!-- <v-btn :disabled="btnSave" color="green" outline dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" outline dark @click="back()">Cancel</v-btn> -->
    </v-toolbar>
    
    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 md4 sm4 style="padding-right: 5px">
            <v-text-field v-model="form.fullName" label="Full name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm4 style="padding-right: 5px">
            <v-text-field v-model="form.mobileNumber" label="Mobile number *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm4 style="padding-right: 5px">
            <v-text-field v-model="form.email" label="Email id" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.userName" label="User name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm12>
            <v-text-field
              v-model="form.passwords"
              label="Password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 md4 sm4>
            <v-autocomplete
              v-model="selectedRoleType"
              :items="roleTypes"
              color="primary"
              label="Select role type *"
              item-text="name"
              item-value="name"
              :rules="emptyRule" 
              required
              clearable
            ></v-autocomplete>
          </v-flex> -->
          <v-flex xs12>
            <v-textarea outline v-model="form.address" label="Address"></v-textarea>
          </v-flex>
         
        </v-layout>
        <v-card-actions>
          <v-btn :disabled="btnSave" color="green" dark @click="onSubmit()">Save </v-btn>
          <v-btn color="red" dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create user",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Users",
          disabled: false,
          to: "/user"
        },
        {
          text: "Create user",
          disabled: true,
          to: "/createUser"
        }
      ],
      roleTypes: null,
      selectedRoleType: null,

      form: {
        userName: null,
        fullName: null,
        address: null,
        passwords: null,
        email: null,
        mobileNumber: null
      }
    };
  },

  mounted() {
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    /* getRoles() {
      this.axios
        .get(config.API + "ApplicationRoles", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.roleTypes = res.data;
        });
    }, */

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Admin`,
            {
              userName: this.form.userName,
              fullName: this.form.fullName,
              mobileNumber: this.form.mobileNumber,
              address: this.form.address,
              email: this.form.email,
              passwords: this.form.passwords
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("User successfully created");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  },

  created() {
    /* this.getRoles(); */
  }
};
</script>

<style>
</style>
